import React from 'react';
import PropTypes from 'prop-types';

import appConfig from 'appConfig';
import { CardStack, SVGIcon } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { FormattedMessage } from 'react-intl';
import summaryShape from 'Workspace/types/pluginSummary';

import PluginDetailsUpdateSection from './PluginDetailsUpdateSection';
import {
  MainDescription,
  HeaderWrapper,
  Header,
  IconWrapper,
  TitlesWrapper,
  Label,
  DetailsWrapper,
  Subtitle,
  StyledLink,
  PlaceholderIcon,
  Placeholder,
} from './styles';
import messages from './messages';

const PluginDetailsCard = ({ summary, releaseDate, author }) => (
  <CardStack
    icon="duotoneBehavior"
    title={intl.formatMessage(messages.pluginDetailsTitle)}
    description={(
      <FormattedMessage
        {...messages.pluginDetailsDescription}
        values={{
          developerDocsLink: <a href={`${appConfig.getDeveloperDocsURL()}/plugins/overview`}>{intl.formatMessage(messages.developerDocsLink)}</a>,
        }}
      />
    )}
  >
    { summary ?
      (
        <DetailsWrapper>
          <HeaderWrapper>
            <Header>
              <IconWrapper>
                <SVGIcon
                  icon={'duotonePlugins'}
                  viewBox="0 0 24 24"
                  primary
                  size={{ height: '64px', width: '64px' }}
                />
              </IconWrapper>
              <TitlesWrapper>
                {summary.name}
                {author &&
                  <Subtitle>
                    {intl.formatMessage(messages.pluginDevelopedBy)} <StyledLink to="developer">{author}</StyledLink>
                  </Subtitle>
                }
              </TitlesWrapper>
            </Header>
            <Label>
              {summary.latestVersion &&
                `${intl.formatMessage(messages.versionShort)}${summary.latestVersion}`
              }
            </Label>
          </HeaderWrapper>
          <MainDescription>
            { summary.description }
          </MainDescription>
          <PluginDetailsUpdateSection
            version={summary.latestVersion}
            pluginId={summary.pluginId}
            releaseDate={releaseDate}
          />
        </DetailsWrapper>
      ) : (
        <DetailsWrapper>
          <HeaderWrapper>
            <Header>
              <IconWrapper>
                <PlaceholderIcon height={64} width={64} />
              </IconWrapper>
              <TitlesWrapper>
                <Placeholder height={30} width={100} />
              </TitlesWrapper>
            </Header>
            <Label>
              <Placeholder width={50} />
            </Label>
          </HeaderWrapper>
          <MainDescription>
            <Placeholder height={30} />
          </MainDescription>
        </DetailsWrapper>
      )
    }
  </CardStack>
);

PluginDetailsCard.propTypes = {
  summary: summaryShape,
  author: PropTypes.string,
  releaseDate: PropTypes.string,
};

export default PluginDetailsCard;
